import React from 'react';
export const MenuDisplayName = {
  Root: 'Root',
  Item: 'Item',
  Content: 'Content',
  Separator: 'Separator',
  Group: 'Group',
  ItemTitle: 'ItemTitle',
  ItemSubtitle: 'ItemSubtitle',
  ItemIcon: 'ItemIcon',
  ItemImage: 'ItemImage',
  Trigger: 'Trigger',
  SubTrigger: 'SubTrigger',
  Sub: 'Sub',
  SubContent: 'SubContent',
  CheckboxItem: 'CheckboxItem',
  Label: 'Label',
  ItemIndicator: 'ItemIndicator',
  Preview: 'Preview',
  Arrow: 'Arrow',
  Auxiliary: 'Auxiliary'
};

/**
 * @deprecated Please use `create` instead.
 */
export const menuify = (Component, displayName) => {
  const MenuComponent = props => {
    return /*#__PURE__*/React.createElement(Component, props);
  };

  MenuComponent.displayName = displayName;
  return MenuComponent;
};
export const create = (Component, displayName) => {
  const MenuComponent = props => {
    return /*#__PURE__*/React.createElement(Component, props);
  };

  MenuComponent.displayName = displayName;
  return MenuComponent;
};
//# sourceMappingURL=display-names.js.map